import React from 'react';
import { Dimmer, Loader, Modal } from 'semantic-ui-react';
import styled from 'styled-components';

const TransparentDimmer = styled(Dimmer)`
  &&& {
    background: transparent !important;
  }
`;

/**
 * This component will return a loader in the middle of the screen with a backdrop background
 */
export default () => (
  <Modal open>
    <TransparentDimmer active>
      <Loader />
    </TransparentDimmer>
  </Modal>
);
